var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"500px","padding-bottom":"82px"}},[_c('vue-editor',{staticStyle:{"height":"100%"},attrs:{"useCustomImageHandler":""},on:{"imageAdded":_vm.handleImageAdded,"input":_vm.EditChange},model:{value:(_vm.Data),callback:function ($$v) {_vm.Data=$$v},expression:"Data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }